import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
}), 'SignalCellularOff');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularOff.js
// module id = 6198
// module chunks = 2